import React from "react";
// Stolen shamelessly from https://github.com/bolteu/beehive-app/blob/68fca1e022e2e8c846cc240b0b728f191a44f05d/common/hooks/useStableCallback.ts#L5
export function useStableCallback(func) {
  const functionRef = React.useRef(func);
  React.useEffect(() => {
    functionRef.current = func;
  }, [func]);
  return React.useCallback(function () {
    return functionRef.current(...arguments);
  }, []);
}